import { render, staticRenderFns } from "./NewPatientMusculoskeletal.vue?vue&type=template&id=f329a4d6&scoped=true&"
import script from "./NewPatientMusculoskeletal.vue?vue&type=script&lang=js&"
export * from "./NewPatientMusculoskeletal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f329a4d6",
  null
  
)

export default component.exports